import { colors } from "../theme/colors";

const { Grey } = colors;
const inputStyles = {
  dropdownFilter: {
    backgroundColor: Grey[200],
    borderRadius: "8px",
    height: "40px",
    color: Grey[500],
    border: "none",
    outline: "none",
    textTransform: "none",
  },
};

export default inputStyles;
